export enum DrugConfigOrg {
  NYCBS = "hwKXreFwPrMpA8Pad7Mr",
  ASTERA = "tPvNbDprUnrXIJlDXyxs",
}
